import { render, staticRenderFns } from "./quickorderMovil_child.vue?vue&type=template&id=eebd8d58&scoped=true"
import script from "./quickorderMovil_child.vue?vue&type=script&lang=js"
export * from "./quickorderMovil_child.vue?vue&type=script&lang=js"
import style0 from "./quickorderMovil_child.vue?vue&type=style&index=0&id=eebd8d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebd8d58",
  null
  
)

export default component.exports